import { useState } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Story } from "../components/Story";
import { Services } from "../components/Services";
import { Gallery } from "../components/Gallery";
import { Testimonials } from "../components/Testimonials";
import { Booking } from "../components/Booking";
import { Footer } from "../components/Footer";

export default function Home() {
    const [selectedService, setSelectedService] = useState("");
    const pickService = (id) => {
        setSelectedService(id);
        document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <>
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Story />
                <Services onSelect={pickService} />
                <Gallery />
                <Testimonials />
                <Booking selectedService={selectedService} setSelectedService={setSelectedService} />
            </main>
            <Footer />
        </>
    );
}
